// src/services/mappers/userMapper.ts
import { ProfileWithCorporateEntitiesDto } from '@generated/api';
import type { UserProfile } from '@typeDefs/domain/profile';
import { corporateEntityMapper } from './corporateEntityMapper';

export const userMapper = {
  fromApi: (apiData: ProfileWithCorporateEntitiesDto): UserProfile => ({
    firstName: apiData.firstName || '',
    lastName: apiData.lastName || '',
    email: apiData.email || '',
    avatarUrl: apiData.avatarUrl || '',
    status: apiData.status || 0, // Default to pending if not provided
    currentCorporateEntityId: null,
    corporateEntities: (apiData.corporateEntities || []).map(corporateEntityMapper.summaryFromApi),
    preferences: {
      theme: apiData.preferences?.theme || 'light',
      notifications: apiData.preferences?.notifications ?? true,
    },
  }),
};
